import React from 'react';
import BentoSplitHero from './BentoSplitHero';
import BannerOverlayHero from './BannerOverlayHero';
import OverlapImagesHero from './OverlapImagesHero';
import CardGridHero from './CardGridHero';
import FoodWrapStyleHero from './FoodWrapStyleHero';
import PresentationHero from './PresentationHero';
import PECoatedStyleHero from './PECoatedStyleHero';
import SilverEnvelopeHero from './SilverEnvelopeHero';
import CupSleeveHero from './CupSleeveHero';
import RippleSleeveHero from './RippleSleeveHero';
import PaperPlatesHero from './PaperPlatesHero';
import SugarSachetHero from './SugarSachetHero';
import PouchesRollHero from './PouchesRollHero';
import CupBottomHero from './CupBottomHero';
import ContainerSleeveHero from './ContainerSleeveHero';
import BoxTraySleeveHero from './BoxTraySleeveHero';
import PECoatedRollHero from './PECoatedRollHero';

const HERO_COMPONENTS = {
  overlap: OverlapImagesHero,
  cardGrid: CardGridHero,
  foodWrap: FoodWrapStyleHero,
  presentation: PresentationHero,
  peCoated: PECoatedStyleHero,
  bannerOverlay: BannerOverlayHero,
  bentoSplit: BentoSplitHero,
  silverEnvelope: SilverEnvelopeHero,
  cupSleeve: CupSleeveHero,
  rippleSleeve: RippleSleeveHero,
  paperPlates: PaperPlatesHero,
  sugarSachet: SugarSachetHero,
  pouchesRoll: PouchesRollHero,
  cupBottom: CupBottomHero,
  containerSleeve: ContainerSleeveHero,
  boxTraySleeve: BoxTraySleeveHero,
  peCoatedRoll: PECoatedRollHero,
};

const ProductHero = ({ variant, content }) => {
  const HeroComponent = HERO_COMPONENTS[variant];

  if (!HeroComponent) {
    return null;
  }

  return <HeroComponent {...content} />;
};

export default ProductHero;
